import { render, staticRenderFns } from "./HeroBar.vue?vue&type=template&id=5a01c356&"
import script from "./HeroBar.vue?vue&type=script&lang=js&"
export * from "./HeroBar.vue?vue&type=script&lang=js&"
import style0 from "./HeroBar.vue?vue&type=style&index=0&id=5a01c356&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports